<template>
    <modal :name="modalName" draggable=".window-header"
           :resizable="true" :width="width" :scrollable="true" height="auto"
           :clickToClose="clickToClose" @before-close="beforeClose" @before-open="beforeOpen">
        <div class="window-header backgrd-grad text-light">
            <b-row>
                <b-col lg="12" class="text-center my-1">
                    <div>
                        {{ title }}
                        <div slot="top-right" class="closebtn" v-if="showCloseBtn">
                            <b-icon icon="x-circle" @click="$modal.hide(modalName)"></b-icon>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-container fluid class="my-2">
            <slot></slot>
        </b-container>
    </modal>
</template>

<script>
    import global from "../../utils/global";

    export default {
        name: "ModalFormEkp",
        props: {
            value: {
                type: Boolean,
                default: true
            },
            showCloseBtn: {
                type: Boolean,
                default: true
            },
            clickToClose: {
                type: Boolean,
                default: false
            },
            modalName: {
                type: String,
                default: "ModalFormEkp"
            },
            title: {
                type: String,
                default: "ModalFormEkp"
            },
            resizable: {
                type: Boolean,
                default: false
            },
            adaptive: {
                type: Boolean,
                default: true
            },
            width: {
                type: Number | String,
                default: 600
            }
        },
        data() {
            return {
                modalOpened : false,
            }
        },
        watch: {
            value(val) {
                if (val)
                    this.$modal.show(this.modalName)
                else
                    this.$modal.hide(this.modalName)
            }
        },
        methods: {
            beforeOpen(event) {
                this.modalOpened = this.value
            },
            beforeClose (event) {
                this.modalOpened = false
                this.$emit("input", this.modalOpened)
            }
        }
    }
</script>

<style>
    .backgrd-grad {background-image: linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)}
    .backgrd-grad {
        /*margin: 10px;*/
        /*padding: 15px 45px;*/
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        display: block;
    }

    .backgrd-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
    .vm--modal {
        height: auto !important;
    }
    .closebtn {
        position: absolute;
        right: 25px;
        top: 1px;
    }
</style>